import { useCallback } from "react";
import { useAppShell } from "@salestrak/ui";

/**
 * Returns a callback that closes the sidebar drawer when on mobile, no-ops
 * on desktop. Use only for non-menu imperative actions inside the sidebar
 * (opening a dialog, firing an RPC, external link). Menu-based interactions
 * auto-close with their own overlay, and route navigation auto-closes via
 * `MobileDrawerAutoClose` in the workspace layout.
 *
 * The drawer is the shell's own `openMobile` state, so this file is a thin
 * named seam over `useAppShell()` rather than a provider of its own.
 */
export function useCloseSidebarIfMobile(): () => void {
  const { isMobile, setOpenMobile } = useAppShell();
  return useCallback(() => {
    if (isMobile) setOpenMobile(false);
  }, [isMobile, setOpenMobile]);
}
